import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between m-3" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Vorheriger Abschnitt ")
const _hoisted_4 = { class: "d-flex ms-5 me-5" }
const _hoisted_5 = {
  key: 1,
  class: "d-flex ms-5 me-5"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Nach Oben ")
const _hoisted_7 = {
  key: 2,
  class: "d-flex"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Nächster Abschnitt ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.previousTopicAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPrevious && _ctx.showPrevious(...args))),
            class: "d-flex",
            role: "link",
            "aria-label": "Vorheriger Abschnitt",
            tabindex: "0"
          }, [
            _createVNode(_component_font_awesome_icon, {
              style: {"margin-right":"10px"},
              icon: ['fas', 'angle-left']
            }),
            _hoisted_3
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showTopicList && _ctx.showTopicList(...args))),
        class: "d-flex",
        role: "link",
        "aria-label": "Übersicht",
        tabindex: "0"
      }, "Übersicht")
    ]),
    (_ctx.canJumpToTop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.jumpToTop && _ctx.jumpToTop(...args))),
            class: "d-flex",
            role: "link",
            "aria-label": "Nach Oben",
            tabindex: "0"
          }, [
            _createVNode(_component_font_awesome_icon, {
              style: {"margin-right":"3px"},
              icon: ['fas', 'chevron-up']
            }),
            _hoisted_6
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.nextTopicAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showNext && _ctx.showNext(...args))),
            class: "d-flex",
            role: "link",
            "aria-label": "Nächster Abschnitt",
            tabindex: "0"
          }, [
            _hoisted_8,
            _createVNode(_component_font_awesome_icon, {
              style: {"margin-left":"10px"},
              icon: ['fas', 'angle-right']
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}